import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c846a0ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "_page_wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "_page_block_contact"
}
const _hoisted_9 = { class: "_half_piece_contact" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_block_title" }, "联系方式", -1))
const _hoisted_11 = { class: "_block_contact_bottom" }
const _hoisted_12 = ["id"]
const _hoisted_13 = {
  key: 0,
  class: "default_text _block_content_contact"
}
const _hoisted_14 = { class: "_half_piece_contact_form" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_block_content_contact" }, "发送留言", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "_half_piece_office" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "office_text" }
const _hoisted_24 = { class: "default_text" }
const _hoisted_25 = { class: "_half_piece_office contact_map" }
const _hoisted_26 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialMedia = _resolveComponent("SocialMedia")!
  const _component_ContactForm = _resolveComponent("ContactForm")!
  const _component_scroll_enter = _resolveComponent("scroll-enter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    (_ctx.pageData.blocks.length>0 && _ctx.pageData.blocks[0].title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData.blocks[0].children, (b2) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: b2.title,
                  class: "_content_"
                }, [
                  _createElementVNode("div", {
                    class: "_block_title_contact",
                    id: b2.title
                  }, _toDisplayString(b2.title), 9, _hoisted_12),
                  (b2.title!='社交媒体')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(b2.content[0]), 1))
                    : _createCommentVNode("", true),
                  (b2.title=='社交媒体')
                    ? (_openBlock(), _createBlock(_component_SocialMedia, {
                        key: 1,
                        iconSize: "width:30px;height:30px;"
                      }))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_ContactForm, { class: "contact_form_itself" })
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _hoisted_19,
    _hoisted_20,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData.blocks[1].children, (block, i) => {
      return (_openBlock(), _createBlock(_component_scroll_enter, {
        _duration: 0.5,
        _delay: 200,
        class: "_page_block_office",
        id: _ctx.idHash(_ctx.pageData.blocks[1].title),
        key: i
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("img", {
              class: "bg_img",
              src: block.images[0],
              alt: ""
            }, null, 8, _hoisted_22),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(block.title), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.content, (l) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: l,
                  class: "default_text"
                }, _toDisplayString(l), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("img", {
              class: "bg_img",
              src: block.map,
              alt: ""
            }, null, 8, _hoisted_26)
          ])
        ]),
        _: 2
      }, 1032, ["_duration", "id"]))
    }), 128))
  ]))
}